<template>
    <b-modal
             id="delete-session-modal"
             :title="title"
             v-model="showModal"
             centered no-close-on-backdrop
             @ok="handleOk"
             @cancel="handleCancel"
             @close="handleCancel">

        <b-overlay :show="isLoading" rounded="sm">

            <ErrorView :visible="isLoadingError" :errorValue="loadingErrorValue"/>

            <b-card v-if="isLoadingError == false" bg-variant="danger" text-variant="white" class="text-center">
                <b-card-text>Warning - Deleting the session cannot be undone, all measurement data for the session will be deleted.</b-card-text>
            </b-card>

        </b-overlay>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="danger" @click="ok()">
                Delete
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
                Cancel
            </b-button>
        </template>

        <b-modal id="error-modal" size="sm" title="Action failed" ok-only centered>
            <p class="m-2">There was a problem completing the action, Please try again.</p>
        </b-modal>

    </b-modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import ErrorView from '../ErrorView'

    export default {
        name: "SessionDeleteModal",
        components: {
            ErrorView
        },
        props: [
            "navigateBack"
        ],
        data() {
            return {
                showModal: false,
                title: "Delete",
                nameValue: null,

            }
        },
        watch: {
            model(newValue) {
                this.resetModel(newValue);
            },
            showModal(newValue) {
                if(newValue) this.resetModel(this.model);
            }
        },
        computed: {
            ...mapGetters({
                model: 'session/current',
                isModelLoading: 'session/currentLoading',
                isModelLoadingError: 'session/currentLoadingError',
                modelLoadingError: 'session/currentLoadingErrorValue',
            }),

            isLoading: function() {
                return this.isModelLoading;
            },
            isLoadingError: function() {
                return this.isModelLoadingError;
            },
            loadingErrorValue: function() {
                return this.modelLoadingError;
            },

        },
        methods: {
            ...mapActions({
                save: 'session/save',
                delete: 'session/delete',
            }),
            resetModel(newValue) {
                if(newValue) {
                    this.nameValue = newValue.name;
                    this.title = "Delete the session '" + this.nameValue + "' ?";

                } else {
                    this.nameValue = null;
                }
            },
            handleOk(bvModalEvt) {

                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if(this.isLoading) {
                    return
                }

                if(this.model != null) {

                    let self = this;
                    this.delete(this.model)
                        .then(function (success) {
                            if(success) {
                                self.resetModel(null);
                                self.closeModal();

                                if(self.navigateBack)
                                  self.$router.back();
                            } else {
                                self.$bvModal.show('error-modal')
                            }
                        })
                }
            },
            handleCancel(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if(this.isLoading) {
                    return
                }

               this.closeModal()

            },
            closeModal() {
                this.$nextTick(() => {
                    this.$bvModal.hide('delete-session-modal')
                })
            }
        }
    }
</script>

<style scoped>

    div.hide-form-group-label {
        color: white;
    }

</style>